export const rules = {
  name: 'name',
  description: 'description',
  startDate: 'start_date',
  endDate: 'end_date',
  segments: 'segments',
  units: 'units',
  activatable: 'activatable',
  offerSales: {
    name: 'offer_sales.[].name',
    price1: 'offer_sales.[].price_1',
    price2: 'offer_sales.[].price_2',
    cashback: 'offer_sales',
    minimumPerClient: 'offer_sales.[].minimum_per_client',
    maximumPerClient: 'offer_sales.[].maximum_per_client',
    active: 'offer_sales.[].active',
  },
  percentageOfferSales: {
    active: 'percentage_offer_sales.[].active',
    name: 'percentage_offer_sales.[].name',
    minimumPerClient: 'percentage_offer_sales.[].minimum_per_client',
    maximumPerClient: 'percentage_offer_sales.[].maximum_per_client',
    percentageDiscount: 'percentage_offer_sales.[].percentage_discount',
  },
  dynamicPricingPercentageOfferSales: {
    active: 'dynamic_pricing_percentage_offer_sales.[].active',
    name: 'dynamic_pricing_percentage_offer_sales.[].name',
    minimumPerClient: 'dynamic_pricing_percentage_offer_sales.[].minimum_per_client',
    maximumPerClient: 'dynamic_pricing_percentage_offer_sales.[].maximum_per_client',
    percentageDiscount: 'dynamic_pricing_percentage_offer_sales.[].percentage_discount',
  },
  takepayOfferSales: {
    active: 'takepay_offer_sales.[].active',
    name: 'takepay_offer_sales.[].name',
    take: 'takepay_offer_sales.[].take',
    pay: 'takepay_offer_sales.[].pay',
    maximumPerClient: 'takepay_offer_sales.[].maximum_per_client',
  },
  comboOfferSales: {
    newCombo: 'combo_offer_sales',
    quantity: 'combo_offer_sales',
    percentageDiscount: 'combo_offer_sales',
    removeImage: 'combo_offer_sales.[].image',
    name: 'combo_offer_sales.[].name',
    maximumPerClient: 'combo_offer_sales.[].maximum_per_client',
  },
  nextbuyCashback: {
    active: 'next_buy_cashback_offer_sales.[].active',
    name: 'next_buy_cashback_offer_sales.[].name',
    cashbackAbsolute: 'next_buy_cashback_offer_sales.[].cashback_absolute_discount',
    maximumPerClient: 'next_buy_cashback_offer_sales.[].max_coupons',
    minimumPerClient: 'next_buy_cashback_offer_sales.[].minimum_per_client',
  },
  cashbackAbsolute: {
    active: 'cashback_absolute_offer_sales.[].active',
    name: 'cashback_absolute_offer_sales.[].name',
    price: 'cashback_absolute_offer_sales.[].price',
    cashbackAbsolute: 'cashback_absolute_offer_sales.[].cashback_absolute',
    maximumPerClient: 'cashback_absolute_offer_sales.[].maximum_per_client',
    minimumPerClient: 'cashback_absolute_offer_sales.[].minimum_per_client',
  },
  dynamic_rule: {
    active: 'dynamic_rule_offer_sales.[].active',
    maximum_per_client: 'dynamic_rule_offer_sales.[].maximum_per_client',
    trigger_amount: 'dynamic_rule_offer_sales.[].trigger_amount',
  },
  cross_sell: {
    active: 'cross_sell_offer_sales.[].active',
    maximum_per_client: 'cross_sell_offer_sales.[].maximum_per_client',
    trigger_amount: 'cross_sell_offer_sales.[].trigger_amount',
  },
}
